import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AnswerClaimInfoRequestRequest, AnswerClaimInfoRequestResponse } from "client/types";
import answerClaimInfoRequest from "./fetchFunctions/answerClaimInfoRequest";
import queryFactory from "./queryFactory";

export default () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      request: AnswerClaimInfoRequestRequest,
    ): Promise<AnswerClaimInfoRequestResponse> => {
      return answerClaimInfoRequest(request);
    },
    onSuccess: (data, variables) => {
      return queryClient.invalidateQueries({
        queryKey: queryFactory.claimInfoRequests(variables.claimId).queryKey,
      });
    },
  });
};
